import { createRouter, createWebHistory } from 'vue-router'
//import test from '../pages/test/Test.vue'
// src/router/index.js

const router = createRouter({
    history: createWebHistory(),
    routes: [
        // {path:'/:pathMatch(.*)*',redirect:test}, //默认路由指向
        // {path:'/test',name:'test', component:test},
        { path: '/', component: () => import('../pages/IndexHome'), name: 'IndexHome', meta: { title: '首页' } },
        { path: '/trade', component: () => import('../pages/trade/indexTrade'), name: 'indexTrade', meta: { title: '行业' ,keepAlive:true} },
        { path: '/product', component: () => import('../pages/product/IndexProduct'), name: 'IndexProduct', meta: { title: '产品',keepAlive:true} },
        { path: '/ai', component: () => import('../pages/ai/IndexAi'), name: 'IndexAi', meta: { title: 'AI 产品' } },
        // Wizwork 产品站：单一路由承接 /ai/wizwork/** 全部文档页；
        // 页面清单与顺序由 pages/ai/wizwork/nav.js 定，内容由 src/content/wizwork/**.md 定
        { path: '/ai/wizwork', redirect: '/ai/wizwork/Overview' },
        { path: '/ai/wizwork/:page(.*)', component: () => import('../pages/ai/wizwork/DocsLayout'), name: 'WizworkDocs', meta: { title: '维思沃客 Wizwork 文档' } },
        { path: '/aboutUs', component: () => import('../pages/aboutUs/index'), name: 'index', meta: { title: '关于我们' } },
        { path: '/detailInstudry/Estate', component: () => import('../pages/detailInstudry/Estate'), name: 'Estate', meta: { title: '产业',keepAlive:true} },
        { path: '/product/SingelProduct', component: () => import('../pages/product/SingelProduct'), name: 'SingelProduct', meta: { title: '产品详细介绍',keepAlive:true} },
        { path: '/productNumber/IndexHome', component: () => import('../pages/productNumber/IndexHome'), name: 'pIndexHome', meta: { title: '各类产品',keepAlive:true} },
    ],
    //顶部显示
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return { left: 0, top: 0 }
        }
    }
})


const SITE = '云南维者科技有限公司 滇ICP备14004983号-4 官方网站'

// 逐路由设置 title —— 全站原本共用一个 title，搜索结果里每一页长得一模一样。
// 文档页的标题由 DocsLayout 按当前文档再覆盖一次（它知道具体是哪一篇）。
router.afterEach((to) => {
    document.title = to.meta && to.meta.title ? to.meta.title + ' · 云南维者科技' : SITE
})

// vue-router 4 下重复导航不再抛未捕获错误，旧的 prototype.push 补丁已无需

export default router
